import React from "react";
import { useApiClient } from "../../../../shared/customHooks";
import { useApplicationContext } from "../../context/applicationContext";
import { groupSupporrtNeedsForm } from "../../../../shared/formObjects/application/legacy/GroupSupportNeedsForm";
import BaseApplicationComponent from "../../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

export default function GroupSupportNeedsComponent({ disabled, data }: any) {
  const formApi = useApiClient("GroupSupportNeeds");
  const { id } = useApplicationContext();

  return (
    <>
      <BaseApplicationComponent
        formBody={groupSupporrtNeedsForm}
        headerLabel="Kindergarten Group Support Needs"
        editPath="groupSupportNeeds"
        apiClient={formApi}
        disabled={disabled}
        data={data}
        id={id}
      />
    </>
  );
}
